import { render, staticRenderFns } from "./EmptyElementItem.vue?vue&type=template&id=6ffba777"
import script from "./EmptyElementItem.vue?vue&type=script&lang=js"
export * from "./EmptyElementItem.vue?vue&type=script&lang=js"
import style0 from "./EmptyElementItem.vue?vue&type=style&index=0&id=6ffba777&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports